// import Vue from 'vue'
// import './plugins/vuetify'
// import App from './App.vue'

// Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')


import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from 'vuetify'
import App from './App.vue'
import colors from 'vuetify/es5/util/colors'
import router from './router'

Vue.config.productionTip = false

// Vue.use(Router)
Vue.use(Vuetify, {
  theme: {
    primary: colors.grey.darken3,
    // primary: "#033e58",
    // secondary: colors.grey.darken1,
    accent: "#ff8000", //colors.orange,
    // error: colors.red.accent3
    
    tournament1: "#aaa",
    tournament2: "#fff"
  }
});

new Vue({
  router,         
  render: (h) => h(App)
}).$mount('#app')